import script from "./CamPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CamPage.vue?vue&type=script&setup=true&lang=js"

import "./CamPage.vue?vue&type=style&index=0&id=2b195a4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b195a4f"]])

export default __exports__